import { Expose } from 'class-transformer'

export class BookTagsType {
  @Expose() id: number

  @Expose() name: string
}
